interface RedAlertIconProps {
  size?: number;
}

export const RedAlertIcon = ({ size = 24 }: RedAlertIconProps) => {
  const iconSize = Number(size) || 24;
  return (
    <svg
      width={iconSize}
      height={iconSize + 1}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="24" height="24" rx="12" fill="#ED3B3B" />
      <g clip-path="url(#clip0_7597_23455)">
        <path
          d="M12 13.0625V9.125"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5629 5.75H9.43711C9.36322 5.74994 9.29004 5.76444 9.22176 5.79267C9.15347 5.8209 9.09142 5.86231 9.03914 5.91453L5.41453 9.53914C5.36231 9.59142 5.3209 9.65347 5.29267 9.72176C5.26444 9.79004 5.24994 9.86322 5.25 9.93711V15.0629C5.24994 15.1368 5.26444 15.21 5.29267 15.2782C5.3209 15.3465 5.36231 15.4086 5.41453 15.4609L9.03914 19.0855C9.09142 19.1377 9.15347 19.1791 9.22176 19.2073C9.29004 19.2356 9.36322 19.2501 9.43711 19.25H14.5629C14.6368 19.2501 14.71 19.2356 14.7782 19.2073C14.8465 19.1791 14.9086 19.1377 14.9609 19.0855L18.5855 15.4609C18.6377 15.4086 18.6791 15.3465 18.7073 15.2782C18.7356 15.21 18.7501 15.1368 18.75 15.0629V9.93711C18.7501 9.86322 18.7356 9.79004 18.7073 9.72176C18.6791 9.65347 18.6377 9.59142 18.5855 9.53914L14.9609 5.91453C14.9086 5.86231 14.8465 5.8209 14.7782 5.79267C14.71 5.76444 14.6368 5.74994 14.5629 5.75Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M12 16.4375C12.466 16.4375 12.8438 16.0597 12.8438 15.5938C12.8438 15.1278 12.466 14.75 12 14.75C11.534 14.75 11.1562 15.1278 11.1562 15.5938C11.1562 16.0597 11.534 16.4375 12 16.4375Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7597_23455">
          <rect width="18" height="18" fill="white" transform="translate(3 3.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
